"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEventHandler = void 0;
var _react = require("react");
var _EventHandlerProvider = require("./EventHandlerProvider");
const noOp = () => {};
const useEventHandler = (component, action, eventConfig) => {
  const config = (0, _react.useContext)(_EventHandlerProvider.EventHandlerContext);
  return (0, _react.useCallback)(() => {
    var _actionMapping$action, _handler$convertedAct;
    if (!config.handlers || !(eventConfig !== null && eventConfig !== void 0 && eventConfig.actions.length)) {
      return noOp();
    }
    const handler = config === null || config === void 0 ? void 0 : config.handlers[component];
    if (!handler) {
      return noOp();
    }
    const actionMapping = config.actionMapping;

    /**
     * Handler can provide an actionMapping object that maps
     * CDS events (onPress, onHover) to its event names.
     * If actionMapping is provided we convert CDS action into the handler one
     * if the mapping between the two values exists
     */
    const convertedAction = (_actionMapping$action = actionMapping === null || actionMapping === void 0 ? void 0 : actionMapping[action]) !== null && _actionMapping$action !== void 0 ? _actionMapping$action : action;

    /**
     * the component event config provides a list of actions to track.
     * If the current action is not listed we return a noOp
     */
    if (!eventConfig.actions.includes(convertedAction)) {
      return noOp();
    }

    // pass event and custom data
    const callback = (_handler$convertedAct = handler[convertedAction]) !== null && _handler$convertedAct !== void 0 ? _handler$convertedAct : noOp;
    return callback({
      componentName: eventConfig.componentName,
      data: eventConfig.data
    });
  }, [action, component, config, eventConfig]);
};
exports.useEventHandler = useEventHandler;